export * as spaceSurveyConfig from './space-survey-config'
